export default __webpack_public_path__ + "static/0g_mobile-6de6dbf11eb8d2009fc7f6dea66e45d6.mp4";